/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core/';

const useStyles = makeStyles(theme => ({
  footer: {
    borderTop: `1px solid ${theme.palette.primary.border}`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: 'relative',
    background: theme.palette.white,
    zIndex: theme.zIndex.drawer + 1,
  },
}));
export default function Footer() {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="xl">
        <Typography>
          {t('messages.cooperation.with')}
          <strong> 
            {' '}
            {t('messages.epo')}
          </strong>
        </Typography>
      </Container>
    </footer>
  );
}
